import isHotkey from 'is-hotkey';

import { isSelectionExpanded } from '../../../../slatePlugins';
import { someNode } from '../../../../slatePlugins/common/queries/someNode';
import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { deserializeEditableBlankVoid } from './deserializeEditableBlankVoid';
import { renderElementEditableBlankVoid } from './renderEditableBlankVoid';
import { EDITABLE_BLANK_VOID, EditableVoidPluginOptions } from './types';

export const EditableVoidPlugin = (options?: EditableVoidPluginOptions): SlatePlugin => {
  return {
    renderElement: renderElementEditableBlankVoid(options),
    voidTypes: [EDITABLE_BLANK_VOID],
    inlineTypes: [EDITABLE_BLANK_VOID],
    deserialize: deserializeEditableBlankVoid(),
    onKeyDown: (e, editor) => {
      const isDeletePress = isHotkey(['Backspace', 'del'], e);
      const isRestrictedAction =
        isDeletePress &&
        someNode(editor, { match: { type: EDITABLE_BLANK_VOID } as any }) &&
        isSelectionExpanded(editor) === false;
      if (isRestrictedAction) {
        e.preventDefault();
        editor.deleteBackward('block');
      }
    },
  };
};
